import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {SettingsStackItemProps, SettingsStackItems, SettingsTemplate} from '@dms/settings/shared';

import {buildArray, composePath} from 'shared/web';

export function WorkshopInterest() {
  const items = buildArray<SettingsStackItemProps>()
    .add({
      title: i18n.t('page.workshop.labels.workshopInterestSeriesDefinition'),
      url: settingsRoutes.workshopInterestSeriesDefinition,
    })
    .add({
      title: i18n.t('page.workshop.labels.workshopInterestSourceCodelist'),
      url: composePath(settingsRoutes.workshopInterestSourceCodelist, {
        params: {id: 'workshop_interest_source'},
      }),
    })
    .add({
      title: i18n.t('page.workshop.labels.workshopInterestCloseReasonCodelist'),
      url: composePath(settingsRoutes.workshopInterestSourceCodelist, {
        params: {id: 'workshop_interest_close_reason'},
      }),
    });

  return (
    <SettingsTemplate
      description={i18n.t('entity.interest.labels.interestDescription')}
      header={{title: i18n.t('entity.interest.labels.interest')}}
      data-testid="settings-workshop-interest"
    >
      <SettingsStackItems items={items} />
    </SettingsTemplate>
  );
}
